import { ESubProject } from '@enums';

import {
	IBrandColors,
	IBrandFileSizes,
} from '@common/containers/Brand/types';

export interface IConfig {
	hosts: {
		api: string;
		static: string;
		staticExternal: string;
		upload: string;
	};

	isServerRendering: boolean;
	isLocalServer: boolean;
	subProject: ESubProject;

	isMobile: boolean;
	isIOs: boolean;
	isAndroid: boolean;

	isAppStoreAvailable: boolean;
	isGooglePlayAvailable: boolean;
	isHuaweiAppGalleryAvailable: boolean;

	isComboWithWink: boolean;

	browserFamily: string;

	comboLink: {
		android: {
			isEnabled: boolean;
			isLink: boolean;
			title: string;
			url: string;
		};
		ios: {
			isEnabled: boolean;
			isLink: boolean;
			title: string;
			url: string;
		};
	};

	urls: {
		stores: {
			appStore: string;
			googlePlay: string;
			huaweiAppGallery: string;
		};
		feedback: string;
		terms: string;
		vkCombo: {
			license: string;
			privacy: string;
		};
	};

	fileUploader: {
		maxFileSize: number;
		maxFilesCount: number;
	};

	landing: {
		hasQrCode: boolean;
		qrCodeLink: string;
		hasParallax: boolean;
	};

	copyright: string;

	brand: {
		fileSizes: IBrandFileSizes;
		colors: IBrandColors;
	};

	isError: boolean;
	isError403: boolean;
	isError404: boolean;
	isError500: boolean;
	isError502: boolean;
}

export const DEFAULT_CONFIG: IConfig = {
	hosts: {
		api: '',
		static: '',
		staticExternal: '',
		upload: '',
	},

	isServerRendering: false,
	isLocalServer: false,
	subProject: null,

	isMobile: false,
	isIOs: false,
	isAndroid: false,

	isAppStoreAvailable: false,
	isGooglePlayAvailable: false,
	isHuaweiAppGalleryAvailable: false,

	isComboWithWink: false,

	browserFamily: '',

	comboLink: {
		android: {
			isEnabled: false,
			isLink: false,
			title: '',
			url: '',
		},
		ios: {
			isEnabled: false,
			isLink: false,
			title: '',
			url: '',
		},
	},

	urls: {
		stores: {
			appStore: '',
			googlePlay: '',
			huaweiAppGallery: '',
		},
		feedback: '',
		terms: '',
		vkCombo: {
			license: '',
			privacy: '',
		},
	},

	fileUploader: {
		maxFileSize: 200 * 1024 * 1024, // 200 Мб
		maxFilesCount: 5,
	},

	landing: {
		hasQrCode: false,
		qrCodeLink: '',
		hasParallax: false,
	},

	copyright: '',

	brand: {
		colors: {
			mainColors: [
				[
					{
						title: 'Pink Light',
						values: {
							hex: '#FF2D55',
							rgb: '255, 45, 85',
							cmyk: 'C0 M90 Y60 K0',
						},
					},
					{
						title: 'Pure Black',
						values: {
							hex: '#000000',
							rgb: '0, 0, 0',
							cmyk: 'C0 M0 Y0 K100',
						},
					},
				],
				[
					{
						title: 'Pink Dark',
						values: {
							hex: '#FF375F',
							rgb: '255, 55, 95',
							cmyk: 'C0 M90 Y50 K0',
						},
					},
					{
						title: 'Pure White',
						values: {
							hex: '#FFFFFF',
							rgb: '255, 255, 255',
							cmyk: 'C0 M0 Y0 K0',
						},
					},
				],
			],
			auxColors: [
				[
					{ title: 'Shy Red', values: { hex: '#D55268' } },
					{ title: 'Forest Green', values: { hex: '#05734E' } },
					{ title: 'Bright Yellow', values: { hex: '#FFD91A' } },
					{ title: 'Gold', values: { hex: '#FFB829' } },
					{ title: 'Sky Light', values: { hex: '#A5E5F2' } },
				],
				[
					{ title: 'Deep Blue', values: { hex: '#27326B' } },
					{ title: 'Orange', values: { hex: '#EB6A28' } },
					{ title: 'So Pink', values: { hex: '#FE5F50' } },
					{ title: 'Purple', values: { hex: '#8E3C8E' } },
				],
			],
		},
		fileSizes: {
			all: 0,
			logotype: {
				color: 0,
				grayScale: 0,
			},
			logogram: {
				color: 0,
				grayScale: 0,
			},
			fonts: 0,
			block: {
				main: 0,
				alternative: 0,
			},
			badge: {
				main: 0,
				dark: 0,
			},
			appIcon: {
				light: 0,
				dark: 0,
			},
			illustrations: 0,
			gradients: 0,
			patterns: 0,
		},
	},

	isError: false,
	isError403: false,
	isError404: false,
	isError500: false,
	isError502: false,
};

let CONFIG = { ...DEFAULT_CONFIG };

export const setConfig = (config: IConfig) => CONFIG = { ...DEFAULT_CONFIG, ...config };

export const getConfig = () => CONFIG;
